import ReactDOM from 'react-dom';
import React from 'react';
import QuotesGallery from '../quote-gallery/quote-gallery';

const init = () => {
    const $placeholders = document.querySelectorAll('[data-type="quotes-gallery"]');

    for(const $placeholder of $placeholders) {
        ReactDOM.render(
            <QuotesGallery />,
            $placeholder
        );
    }
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});
